module.exports = __webpack_public_path__ + "static/media/measurePoint.908100c7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/measurePoint.svg
// module id = 1298
// module chunks = 0